import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

interface SummaryCardsProps {
  totalLinks: number;
  articleLinks: number;
  homepageLinks: number;
  sitewideLinks: number;
  validLinks: number;
  invalidLinks: number;
  uncheckedLinks: number;
  uniqueAnchors: number;
  lastPublishedAt: string | null;
}

export function SummaryCards(props: SummaryCardsProps) {
  const {
    totalLinks,
    articleLinks,
    homepageLinks,
    sitewideLinks,
    validLinks,
    invalidLinks,
    uncheckedLinks,
    uniqueAnchors,
    lastPublishedAt,
  } = props;

  return (
    <Box display="flex" flexWrap="wrap" gap={2} mb={3}>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Всего ссылок
            </Typography>
            <Typography variant="h5">{totalLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Активных
            </Typography>
            <Typography variant="h5">{validLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Исчезнувших
            </Typography>
            <Typography variant="h5">{invalidLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Не проверялись
            </Typography>
            <Typography variant="h5">{uncheckedLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Статьи
            </Typography>
            <Typography variant="h5">{articleLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Главная
            </Typography>
            <Typography variant="h5">{homepageLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Sitewide
            </Typography>
            <Typography variant="h5">{sitewideLinks}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Уникальных анкоров
            </Typography>
            <Typography variant="h5">{uniqueAnchors}</Typography>
          </CardContent>
        </Card>
      </Box>
      <Box flex="1 1 160px">
        <Card>
          <CardContent>
            <Typography color="text.secondary" variant="body2">
              Последняя публикация
            </Typography>
            <Typography variant="h5">
              {lastPublishedAt !== null ? new Date(lastPublishedAt).toLocaleString() : "—"}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
